<template>
  <div class="dates__line">
    <div class="dates__row">
      <div>{{ trainee.firstname + ' ' + trainee.lastname }}</div>
      <div>{{ trainee.email }}</div>
    </div>
    <div class="dates__btn">
      <button
        class="btn btn-primary"
        @click.stop.prevent="showEditTraineesModal($event, trainee)"
      >
        {{$t('editButton')}}
      </button>
      <button class="btn btn-danger" @click.stop.prevent="remove">
       {{$t('deleteButton')}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamRow',
  props: ['trainee', 'index', 'isLast'],
  components: {},
  data() {
    return {}
  },
  computed: {
    birthday() {
      if (this.$lodash.get(this.trainee, 'birthday', false)) {
        return this.$moment(this.trainee.birthday).format('YYYY-DD-MM')
      }
    },
  },
  mounted() {},
  methods: {
    showEditTraineesModal(event, trainee) {
      let data = {}
      data.trainee = trainee
      this.$bus.$emit('trainee-settings-modal.show', data)
    },
    remove() {
      let data = {}
      data.title = 'Confirmation'
      data.message = `${this.$t('deleteConfirmation')}
            <span class="text-nowrap">
              ${ this.trainee.lastname + ' ' + this.trainee.firstname}
            </span>  ?`
      data.data = this.trainee
      data.event = 'delete-trainee-confirmation'
      data.next = this.destroy
      this.$bus.$emit('confirmation-modal.show', data)
    },
  },
}
</script>

<style></style>
